import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import {isUndefined} from "lodash-es";

/**
 * Wiadomość globalna, gdy rozpoczęto wyszukiwanie dostępności
 */
export class AvailabilitySearchStarted extends NfComponentGlobalMessage {
    declare public getAvailabilityRequestId: number;

    public constructor(getAvailabilityRequestId: number|MessageEvent<AvailabilitySearchStarted>) {
        super(NfMessageType.AvailabilitySearchStarted, !NfMessage.isMessageEvent(getAvailabilityRequestId));
        if(NfMessage.isMessageEvent(getAvailabilityRequestId)) {
            Object.assign(this, getAvailabilityRequestId.data);
        } else {
            if(isUndefined(getAvailabilityRequestId) || getAvailabilityRequestId === null) {
                throw Error('getAvailabilityRequestId jest wymagany');
            }
            this.getAvailabilityRequestId = getAvailabilityRequestId;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.AvailabilitySearchStarted] = (event) => {
    return new AvailabilitySearchStarted(event);
}
